module.exports = __webpack_public_path__ + "static/media/THUGS-NAR.38407b67.png";